<template>
  <section>
    <b-modal v-model="show" :width="1000" scroll="keep" :on-cancel="closeModal">
      <ModalAddComponent>
        <button @click="closeModal" class="btn-close">&times;</button>
        <div class="modal-widget" id="#add_component_cotainer">
          <div class="modal-title">
            <h2 class="title">
              <i class="mr-2 mdi mdi-plus"></i> Agregar componente
            </h2>
          </div>
          <div class="modal-body">
            <div class="columns">
              <div class="column">
                <b-field label="Tipo">
                  <b-select
                    placeholder="Tipo *"
                    name="type"
                    v-model="type"
                    v-validate="'required'"
                    expanded
                  >
                    <option
                      v-for="option in listTypes"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                    >
                      {{ option.title }}
                    </option>
                  </b-select>
                </b-field>
                <span class="show-error">{{ errors.first("type") }}</span>
              </div>
              <div class="column">
                <b-field label="Nombre [name] *">
                  <b-input
                    placeholder="Nombre de identificador"
                    type="text"
                    name="keyname"
                    v-model="keyname"
                    v-validate="'required'"
                  />
                </b-field>
                <span class="show-error">{{ errors.first("keyname") }}</span>
              </div>
              <div class="column">
                <b-field label="Título [label] *">
                  <b-input
                    placeholder="Título - [label]"
                    type="text"
                    name="title"
                    v-model="title"
                    v-validate="'required'"
                  />
                </b-field>
                <span class="show-error">{{ errors.first("title") }}</span>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-checkbox
                  name="required"
                  v-model="required"
                  true-value="true"
                  false-value="false"
                >
                  Requerido
                </b-checkbox>
              </div>
            </div>
            <fieldset class="fieldset component-preview">
              <legend>Vista previa</legend>
              <div class="body-container">
                <dinamyc-field
                  v-if="field"
                  v-bind:field="field"
                  v-bind:index="0"
                  v-bind:dinamycValueFields="dinamycValueFields"
                />
              </div>
              <fieldset class="fieldset mt-3" v-if="type === 'select'">
                <legend>Opciones selector</legend>
                <div class="options-selector-container">
                  <div
                    v-if="type === 'select' && selectOptions.length > 0"
                    class="options-container mt-2"
                  >
                    <b-table
                      :data="selectOptions"
                      :paginated="true"
                      :per-page="3"
                      :bordered="true"
                      :current-page.sync="currentPage"
                    >
                      <b-table-column
                        field="plate"
                        label="Valor"
                        v-slot="props"
                      >
                        <b-field>
                          <b-input
                            placeholder="Valor"
                            type="number"
                            name="value"
                            v-model="props.row.id"
                          />
                        </b-field>
                      </b-table-column>
                      <b-table-column
                        field="plate"
                        label="Descripción"
                        v-slot="props"
                      >
                        <b-field>
                          <b-input
                            placeholder="Descripción"
                            type="text"
                            name="description"
                            v-model="props.row.text"
                          />
                        </b-field>
                      </b-table-column>
                      <b-table-column
                        field="plate"
                        label="Opciones"
                        v-slot="props"
                      >
                        <vs-button
                          color="danger"
                          class="pl-5 pr-5"
                          type="filled"
                          title="Eliminar"
                          icon="delete"
                          @click="deleteRow(props.row)"
                        >
                        </vs-button>
                      </b-table-column>
                    </b-table>
                  </div>
                  <vs-button
                    color="primary"
                    class="pl-5 pr-5 mt-2"
                    type="filled"
                    icon="add"
                    @click="addOption"
                  >
                    Agregar opción
                  </vs-button>
                </div>
              </fieldset>
            </fieldset>
          </div>
          <div class="modal-footer">
            <vs-button
              color="success"
              class="pl-5 pr-5"
              type="filled"
              icon="add"
              @click="addComponent"
            >
              Agregar
            </vs-button>
          </div>
        </div>
      </ModalAddComponent>
    </b-modal>
  </section>
</template>

<script>
import { ModalAddComponent } from "./styles";
import DinamycField from "../../devices/configuration/DinamycField.vue";
import { confirmation } from "../../../global/utils";
import { configToast, TOAST_TYPES } from "../../../global/toast";
export default {
  components: { ModalAddComponent, DinamycField },
  props: ["pushComponent"],
  data: () => ({
    show: false,
    type: null,
    currentPage: 1,
    selected: null,
    title: null,
    required: null,
    field: null,
    keyname: null,
    selectOptions: [],
    dinamycValueFields: {},
    listTypes: [
      {
        code: "text",
        title: "Texto",
      },
      {
        code: "select",
        title: "Selector de opciones",
      },
      {
        code: "number",
        title: "Número",
      },
      {
        code: "checkbox",
        title: "Checkbox",
      },
    ],
  }),
  watch: {
    title: function () {
      this.field = { ...this.field, title: this.title };
    },
    type: function () {
      this.typeAction();
    },
  },
  mounted() {
    this.type = this.listTypes[0].code;
  },
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#company_container");
      return instance.open(message, type);
    },
    typeAction() {
      const selectedType = this.listTypes.find(
        (item) => item.code === this.type
      );
      const tempField = {
        type: this.type,
        key: this.keyname,
        title: this.title ? this.title : selectedType.title,
      };
      if (this.type === "select") {
        tempField.options = this.selectOptions;
      }
      this.field = tempField;
    },
    deleteRow(row) {
      console.log("DELETE ROW", row);
      confirmation(this, "¿Deseas eliminar el item actual?").then((result) => {
        if (result) {
          this.selectOptions = this.selectOptions.filter(
            (item) => item.index !== row.index
          );
        }
      });
    },
    clearForm() {
      this.currentPage = 1;
      this.selectOptions = [];
      this.field = null;
      this.title = null;
      this.keyname = null;
      this.type = "text";
      this.typeAction();
      this.dinamycValueFields = {};
    },
    addOption() {
      const { selectOptions } = this;
      selectOptions.push({
        index: this.selectOptions.length,
        id: this.selectOptions.length + 1,
        text: `Opción ${this.selectOptions.length + 1}`,
        required: this.required,
      });
      this.selectOptions = selectOptions.sort((a, b) => {
        return b.index - a.index;
      });
      const tempField = { ...this.field };
      if (this.type === "select") {
        console.log("TYPE ES SELECT");
        tempField.options = this.selectOptions;
      }
      this.field = tempField;
    },
    addComponent() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.toast("Debes completar el formulario", TOAST_TYPES.ERROR);
          return;
        }
        this.$emit("pushComponent", {
          ...this.field,
          key: this.keyname,
          required: this.required,
        });
        this.field = null;
        this.closeModal();
      });
    },
    openModal() {
      this.clearForm();
      this.show = true;
    },
    closeModal() {
      this.show = false;
    },
  },
};
</script>
